<template>
    <div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :bizDepart="true" :showIncludeSubComs="false" :initIncludeSubComs="false" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <div class="simple-form" v-if="channelCode == 'bizParamComn'">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">开启岗位组织</label>
                </div>
                <div class="form-value">
                    <el-radio-group v-model="comInfo.postOrgEnabled">
                        <el-radio class="radio" :label=false>否</el-radio>
                        <el-radio class="radio" :label=true>是</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">开启岗位商品分类</label>
                </div>
                <div class="form-value">
                    <el-radio-group v-model="comInfo.postGoodsCatEnabled">
                        <el-radio class="radio" :label=false>否</el-radio>
                        <el-radio class="radio" :label=true>是</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">开启岗位服务分类</label>
                </div>
                <div class="form-value">
                    <el-radio-group v-model="comInfo.postServcCatEnabled">
                        <el-radio class="radio" :label=false>否</el-radio>
                        <el-radio class="radio" :label=true>是</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center" v-if="comInfo.shopFlag">
                <div class="form-label">
                    <label class="required">工单派工后(X小时)未响应-自动作废</label>
                </div>
                <div class="form-value">
                    <el-input class="width-1-5x" type="number" v-model="comInfo.autoInvalidAfterNoRspInHours"></el-input>
                    <span>小时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注: 值为0时不自动作废</span>
                </div>
            </div>
        </div>
        <div class="simple-form" v-if="channelCode == 'bizParamRepair' && comInfo.shopFlag">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">工单默认绩效标记</label>
                </div>
                <div class="form-value">
                    <el-radio-group v-model="comInfo.performFlag">
                        <el-radio class="radio" :label=1>保底</el-radio>
                        <el-radio class="radio" :label=2>计件</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center" v-if="comInfo.performFlag == 2">
                <div class="form-label">
                    <label class="required">默认计件比率(%)</label>
                </div>
                <div class="form-value">
                    <el-input class="align-right" type="number" :max="100" :min="0" step="1" v-model="comInfo.jbRatio"></el-input>
                    <div class="input-tip error">0% ~ 100%</div>
                </div>
            </div>
        </div>
        <div class="form-row align-center mt20" v-if="channelCode == 'bizParamComn' || (channelCode == 'bizParamRepair' && comInfo.shopFlag)">
            <a class="swb-btn mb20" id="saveBtn" @click="submitForm();">保存</a>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import appConf from '../../app.conf';
    import { openComStaffMainForSelectDlg, openComStaffComnSelectDlg } from '../orgStruct/selectDlg'

    import userApi from '../../api/user'
    import servicerApi from '../../api/servicer'

    import SwbPopoverOrgTree from '../orgStruct/PopoverOrgTree';
    import ElInput from '../../../node_modules/element-ui/packages/input/src/input';
    Vue.regist(SwbPopoverOrgTree);

    export default {
        name: 'swb-org-biz-param-list',
        desc: '机构级业务参数设置',
        props: {
            channelCode: {
                default: null
            }
        },
        data: function () {
            return {
                comInfo: {}
            }
        },
        created: function () {
            this.getUserInfoByContext();
        },
        methods: {
            getUserInfoByContext: function () {
                let self = this;
                userApi.getUserInfoByContext(null, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let userContext = result.data;
                        let scopeEntity = userContext.scopeEntity;
                        //
                        self.getComInfo(scopeEntity.comId);
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            checkComCatChange: function (eventDate) {
                this.getComInfo(eventDate.id);
            },
            getComInfo: function (comId) {
                let self = this;
                let postData = {
                    comId: comId
                };
                let theLoad = MsgBox.loading();
                servicerApi.getServicerCom(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let comInfo = result.data;
                        comInfo.jbRatio = comInfo.jbRatio * 100;
                        self.comInfo = comInfo;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 保存
            submitForm: function () {
                let self = this;
                self.comInfo.noFlag = true;
                let comInfo = self.comInfo;
                let updateCom = {};
                updateCom.id = comInfo.id;
                if(self.channelCode == 'bizParamComn') {
                    updateCom.postOrgEnabled = comInfo.postOrgEnabled;
                    updateCom.postGoodsCatEnabled = comInfo.postGoodsCatEnabled;
                    updateCom.postServcCatEnabled = comInfo.postServcCatEnabled;
                } else if(comInfo.shopFlag) {
                    updateCom.performFlag = comInfo.performFlag;
                    if(updateCom.performFlag == 2) {
                        let jbRatio = comInfo.jbRatio;
                        //
                        if(!Utils.isNaturalStr(jbRatio) || jbRatio < 0 || jbRatio > 100) {
                            self.$message.warning("计件比率必须是整数且在 0% ~ 100% 之间");
                            return false;
                        }
                        if(jbRatio != 0) {
                            updateCom.jbRatio = jbRatio / 100;
                        }
                    }
                }
                if(Utils.isNoB(comInfo.autoInvalidAfterNoRspInHours)) {
                    self.$message.warning("[工单派工后（x小时）未响应-自动作废]单元不可为空");
                    return false;
                } else {
                    updateCom.autoInvalidAfterNoRspInHours = comInfo.autoInvalidAfterNoRspInHours;
                }
                let theLoad = MsgBox.loading();
                servicerApi.updateServicerComParams(updateCom, function (result, jqXhr) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.$message.success('保存成功');
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizParam/OrgBizParamList.vue